// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__17CnA","name":"ConsentHeader_name__18DSg","birthday":"ConsentHeader_birthday__2Pj1M","skeleton":"ConsentHeader_skeleton__3LXE9"};